import { apiCall, apiClient } from './api';

// Types
export interface LogEntry {
  timestamp: string;
  message: string;
  logStreamName: string;
}

export interface LogSearchResponse {
  traceId: string;
  totalLogs: number;
  logs: LogEntry[];
  searchDuration: number;
}

export interface XRayTraceInfo {
  traceId: string;
  duration?: number;
  statusCode?: number;
  url?: string;
  method?: string;
}

// Admin Logs API
export const adminLogsApi = {
  async searchByTraceId(traceId: string, hoursBack: number = 24): Promise<LogSearchResponse> {
    return apiCall(() =>
      apiClient.get<LogSearchResponse>('/api/v1/admin/logs/search', {
        params: { trace_id: traceId, hours_back: hoursBack },
      })
    );
  },

  async getTraceInfo(traceId: string): Promise<XRayTraceInfo> {
    return apiCall(() =>
      apiClient.get<XRayTraceInfo>('/api/v1/admin/logs/trace', {
        params: { trace_id: traceId },
      })
    );
  },

  async getRecentLogs(minutes: number = 5, limit: number = 100): Promise<LogEntry[]> {
    return apiCall(() =>
      apiClient.get<LogEntry[]>('/api/v1/admin/logs/recent', {
        params: { minutes, limit },
      })
    );
  },
};
